import { render, staticRenderFns } from "./SupportText.vue?vue&type=template&id=272b53ac"
import script from "./SupportText.vue?vue&type=script&lang=js"
export * from "./SupportText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports